import type { FlightClass } from "@/types/flights";
import { useTranslations } from "next-intl";
import { RadioDropdown } from "../RadioDropdown/RadioDropdown";
import { getFlightClassOptions } from "../useSearchFlights";

type Props = {
  value: FlightClass;
  onChange: (value: FlightClass) => void;
  isFullScreenModal?: boolean;
  className?: string;
};

const isFlightClass = (value: string): value is FlightClass => {
  return ["economy", "premium_economy", "business", "first"].includes(value);
};

const getValue = (value: string): FlightClass => {
  return isFlightClass(value) ? value : "economy";
};

const FlightClassDropdown = ({
  onChange,
  value,
  isFullScreenModal = false,
  className,
}: Props) => {
  const t = useTranslations();
  return (
    <RadioDropdown
      value={value}
      options={getFlightClassOptions(t)}
      name="flightClass"
      id="flight-class"
      onChange={(value) => onChange(getValue(value))}
      isFullScreenModal={isFullScreenModal}
      className={className}
    />
  );
};

export default FlightClassDropdown;
